import React from 'react';
import styled from 'styled-components';

const FooterContainer = styled.div`
  position: fixed;
  bottom: 10px;
  left: 10px;
  font-size: 12px;
  color: #666;
  z-index: 10;
  background-color: rgba(255, 255, 255, 0.7);
  padding: 5px 10px;
  border-radius: 5px;
`;

const Link = styled.a`
  color: #4a90e2;
  text-decoration: none;
  
  &:hover {
    text-decoration: underline;
  }
`;

const Footer = () => {
  return (
    <FooterContainer>
      <div>Healing Out Loud &copy; {new Date().getFullYear()}</div>
      <div>
        <Link 
          href="https://www.instagram.com/mynameisheno?igsh=NTc4MTIwNjQ2YQ==" 
          target="_blank" 
          rel="noopener noreferrer"
        >
          Heno.
        </Link>
        {' | '}
        <Link 
          href="https://www.instagram.com/madkeys_?igsh=NTc4MTIwNjQ2YQ==" 
          target="_blank" 
          rel="noopener noreferrer"
        >
          Mad Keys
        </Link>
      </div>
    </FooterContainer>
  );
};

export default Footer; 